import m from "./_baseFlatten.js";
import o from "./_baseOrderBy.js";
import n from "./_baseRest.js";
import b from "./_isIterateeCall.js";
var p = m, s = o, u = n, l = b, _ = u(function(a, r) {
  if (a == null)
    return [];
  var f = r.length;
  return f > 1 && l(a, r[0], r[1]) ? r = [] : f > 2 && l(r[0], r[1], r[2]) && (r = [r[0]]), s(a, p(r, 1), []);
}), t = _;
export {
  t as default
};
//# sourceMappingURL=sortBy.js.map
